import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DrawCollapseDirectiveSharedModule } from '@shared/core/directives/drawCollapse/draw-collapse.directive.shared.module';
import { SearchForLocationsFilterModule } from '@shared/core/components/search/searchTypes/forLocationsFilter';
import { LinkModule } from '@shared/core/components/link';
import { BtnModule } from '@shared/core/components/buttons/btn/btn.shared.module';
import { PickupForFilterModule } from '@shared/core/components/pickup/pickupTypes/forFilter';
import { SubNavModule } from '@shared/core/components/subNav';
import { ProjectionModule } from '@shared/core/components/projection';
import { OnlineMenuNavModule } from '@shared/core/components/onlineMenuNav';
import { AccountDrawMenuModule } from '@shared/core/modules/account/components/accountDrawMenu';

import { FiltersDrawComponent } from './filters-draw.shared.component';

@NgModule({
    declarations: [
        FiltersDrawComponent,
    ],
    imports: [
        CommonModule,
        ProjectionModule,
        SubNavModule,
        OnlineMenuNavModule,
        SearchForLocationsFilterModule,
        LinkModule,
        BtnModule,
        PickupForFilterModule,
        DrawCollapseDirectiveSharedModule,
        AccountDrawMenuModule,
    ],
    exports: [
        FiltersDrawComponent,
    ],
})
export class FiltersDrawModule { }
